import {z} from "zod";

export const depositPagoMovilSchema = z.object({
  referencia: z
    .string()
    .trim()
    .min(4, "La referencia debe tener al menos 4 dígitos")
    .max(20, "La referencia es demasiado larga")
    .regex(/^\d+$/, "Solo números"),
  importe: z.coerce.number({message: "Monto inválido"}).positive("El monto debe ser mayor a 0"),
  fecha: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Formato de fecha inválido (YYYY-MM-DD)"),
  banco_origen: z.string().trim().min(3, "Selecciona un banco"),
});

export type DepositPagoMovilFormInput = z.input<typeof depositPagoMovilSchema>;
export type DepositPagoMovilPayload = z.output<typeof depositPagoMovilSchema>;
